import { render } from "./BaseContainer.vue?vue&type=template&id=4010e239&ts=true"
import script from "./BaseContainer.vue?vue&type=script&lang=ts"
export * from "./BaseContainer.vue?vue&type=script&lang=ts"

import "./BaseContainer.vue?vue&type=style&index=0&id=4010e239&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__